import gsap from 'gsap';

const bar = document.querySelector('.loading__bar--inner');
const loadingNumber = document.querySelector('.loading__counter--number');
const loading = document.querySelector('.loading');

const header = document.querySelector('.header');
const socials = document.querySelector('.socials');
const intro = document.querySelector('.intro');
const skills = document.querySelector('.skills');

import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';

let c = 0;
let loadingComplete = false;

let barInterval = setInterval(() => {

    bar.style.width = `${c}%`;
    loadingNumber.innerHTML = `${c}%`;
    c++;

    if (c > 100) {
        clearInterval(barInterval);
        gsap.to('.loading__bar', { duration: 5, rotate: '90deg', left: '1000%'});

        gsap.to('.loading__text, .loading__counter', { duration: 0.5, opacity:0 });

        gsap.to('.loading__box', { duration: 1, height: "350px", borderRadius: '50%'});
            // Este código se ejecutará cuando la animación termine
            gsap.to('.loading__svg', {opacity: 1, rotate: '360deg', duration: 10 });

            gsap.to('.loading__box', {delay : 2, border: "none", duration : 1});


            gsap.to('.loading__svg', {delay: 9, duration: 100, rotate: '+=360deg', opacity: 0.5});

            gsap.to('.loading', {delay: 5, duration: 2, background: "transparent", onComplete: () => {
                loading.style.zIndex = -1;
            }});


            /* gsap.to('.loading', {onComplete: () => {
                zIndex: -1;

            }}); */

            /* to make hoverable these items again */
           /*  header.style.zIndex = 2;
            socials.style.zIndex = 2;
            intro.style.zIndex = 2;
            skills.style.zIndex = 2; */
        let options = {
            alwaysShowsTracks: true,
            damping: 2,
            plugins: {
                disableScroll: {
                    direction: 'x',
                },
            },
        }

        //let pageSmoothScroll = Scrollbar.init(document.body);
        //pageSmoothScroll.track.xAxis.element.remove()
    }  
}, 10);


/* FAC */
const questions = [...document.querySelectorAll('.question')];

questions.map((question) => {
    let q_title = question.querySelector('h3');

    
    q_title.addEventListener('click', () => {
        questions.filter((q) => q!== question).map((q) => q.classList.remove('open'));

        question.classList.toggle('open');
    });
});

    



  
